module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "foo"
  }, [_c('H1', [_vm._v("Istorija kupona - " + _vm._s(_vm.companyName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "form-label"
  }, [_vm._v("Od: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }],
    staticClass: "input",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "date",
      "placeholder": "Od: ",
      "name": "email"
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "change": _vm.changedDateFrom,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label"
  }, [_vm._v("Do: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toDate),
      expression: "toDate"
    }],
    staticClass: "input",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "date",
      "placeholder": "Do: ",
      "name": "email"
    },
    domProps: {
      "value": (_vm.toDate)
    },
    on: {
      "change": _vm.changedDateTo,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toDate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "button button-outline",
    staticStyle: {
      "background": "#2b542c",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.getHistory()
      }
    }
  }, [_c('i', {
    staticClass: "ti-search"
  }), _vm._v("  Pretraži\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "input",
    staticStyle: {
      "width": "90%",
      "border-radius": "10px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Pretraga",
      "name": "users"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.isAdmin && _vm.companyId != null) ? _c('div', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showOrders),
      expression: "showOrders"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox",
      "name": "users"
    },
    domProps: {
      "checked": Array.isArray(_vm.showOrders) ? _vm._i(_vm.showOrders, null) > -1 : (_vm.showOrders)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.showOrders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showOrders = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showOrders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showOrders = $$c
        }
      }
    }
  })]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.companyId != null) ? _c('div', [(_vm.showOrders) ? _c('label', {
    staticStyle: {
      "color": "white",
      "font-size": "20px"
    }
  }, [_vm._v("Ukupno: " + _vm._s(_vm.total))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('span', [(_vm.companyId != null) ? _c('button', {
    staticClass: "button button-outline",
    staticStyle: {
      "background": "cornflowerblue"
    },
    on: {
      "click": function($event) {
        return _vm.resetCompanyCupons()
      }
    }
  }, [_c('i', {
    staticClass: "ti-reload"
  }), _vm._v("  Restartuj stanje kompanije na 0\n              ")]) : _vm._e()]), _vm._v(" "), _c('span', [(_vm.showOrders && _vm.filteredUsers.length > 0 && _vm.companyId != null) ? _c('button', {
    staticClass: "button button-outline",
    staticStyle: {
      "background": "cornflowerblue"
    },
    on: {
      "click": function($event) {
        return _vm.downloadSpecification(false)
      }
    }
  }, [_c('i', {
    staticClass: "ti-download"
  }), _vm._v("  Specifikacija\n              ")]) : _vm._e()]), _vm._v(" "), _c('span', [(_vm.showOrders && _vm.filteredUsers.length > 0 && _vm.companyId != null) ? _c('button', {
    staticClass: "button button-outline",
    staticStyle: {
      "background": "cornflowerblue"
    },
    on: {
      "click": function($event) {
        return _vm.downloadSpecification(true)
      }
    }
  }, [_c('i', {
    staticClass: "ti-email"
  }), _vm._v("  Posalji Specifikaciju\n              ")]) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Ukupno:\n      "), _c('span', [_vm._v("\n                                " + _vm._s(_vm.amount) + "\n                                "), _c('img', {
    staticStyle: {
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "src": require("../../assets/img/coin.png")
    }
  })])]), _vm._v(" "), _c('br'), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed",
    staticStyle: {
      "margin-bottom": "100px"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "50px",
      "color": "white"
    }
  }, [_vm._v("R. br")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Kod")]), _vm._v(" "), (_vm.companyId == null) ? _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Kompanija")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Datum")]), _vm._v(" "), (_vm.tabIndex === 1) ? _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Detalji porudžbine")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px",
      "color": "white"
    }
  }, [_vm._v("Krediti")]), _vm._v(" "), (_vm.isAdmin && _vm.companyId != null) ? _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Adresa dostave")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v("Pošalji fakturu")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v("Skini fakturu")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v("EFAKTURA")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v("Obriši")])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredUsers), function(item, index) {
    return _c('tr', {
      staticStyle: {
        "color": "white",
        "background-color": "#4E5066 !important"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm.filteredUsers.length - index))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_c('b', [_vm._v("#" + _vm._s(item.id.substr(0, 6)) + _vm._s(_vm.format2Date(item.timestamp)))])]), _vm._v(" "), (_vm.companyId == null) ? _c('td', [_vm._v(_vm._s(item.company.name))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_vm._v(_vm._s(_vm.formatDate(item.timestamp)))]), _vm._v(" "), (_vm.tabIndex === 1) ? _c('td', [_vm._v("\n              " + _vm._s(item != null && item.order.address != null ? item.order.address.street : '') + _vm._s(item != null && item.order.address != null ? ', ' + item.order.address.city : '') + "\n            ")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_c('span', [_vm._v("\n                              " + _vm._s(item.greenVouchers) + "\n                              "), _c('img', {
      staticStyle: {
        "width": "20px",
        "height": "20px"
      },
      attrs: {
        "src": require("../../assets/img/coin.png")
      }
    })])]), _vm._v(" "), (_vm.isAdmin && _vm.companyId != null) ? _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_vm._v(_vm._s(_vm.getAddress(item)))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [(_vm.getAddress(item) === '') ? _c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "cornflowerblue"
      },
      attrs: {
        "type": "button",
        "placeholder": "Pošalji na mail",
        "name": "Pošalji na mail",
        "value": "Pošalji na mail"
      },
      on: {
        "click": function($event) {
          return _vm.sendInvoice(item)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [(_vm.getAddress(item) === '') ? _c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "cornflowerblue"
      },
      attrs: {
        "type": "button",
        "placeholder": "Skini",
        "name": "Skini",
        "value": "Skini"
      },
      on: {
        "click": function($event) {
          return _vm.onlyDownload(item)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [(_vm.getAddress(item) === '' && (item.invoice == null)) ? _c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "darkolivegreen"
      },
      attrs: {
        "type": "button",
        "placeholder": "Pošalji na portal (pdv)",
        "name": "Pošalji na portal (pdv)",
        "value": "Pošalji na portal (pdv)"
      },
      on: {
        "click": function($event) {
          return _vm.generateEfaktura(item)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.getAddress(item) === '' && (item.invoice != null)) ? _c('div', [(item.invoice.error == null && item.invoice.statusError == null) ? _c('div', [_vm._v(_vm._s(_vm.getStatusEfaktra(item)) + "\n                  "), (item.invoice.status === 'LOADING') ? _c('div', {
      staticClass: "loader",
      staticStyle: {
        "width": "20px",
        "height": "20px"
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.invoice.error != null) ? _c('a', {
      staticStyle: {
        "color": "red",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.generateEfaktura(item)
        }
      }
    }, [_vm._v(_vm._s(item.invoice.error) + " "), _c('i', {
      staticClass: "ti-reload"
    })]) : _vm._e(), _vm._v(" "), (item.invoice.statusError != null && item.invoice.error == null) ? _c('a', {
      staticStyle: {
        "color": "red",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.getInvoiceJSONById(item.invoice.SalesInvoiceId)
        }
      }
    }, [_vm._v(_vm._s(item.invoice.statusError) + " "), _c('i', {
      staticClass: "ti-reload"
    })]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "#843534"
      },
      attrs: {
        "type": "button",
        "placeholder": "Obriši",
        "name": "Obriši",
        "value": "Obriši"
      },
      on: {
        "click": function($event) {
          return _vm.deleteVoucher(item.id)
        }
      }
    })])])
  }), 0)])])])]), _vm._v(" "), _c('add-company-stuff-modal', {
    attrs: {
      "show": _vm.openAddOrder,
      "companyId": _vm.companyId
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('label', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "for": "checkbox"
    }
  }, [_vm._v("Prikaži sve kredite koji su potrošeni")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-04509873!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Company/VoucherHistory.vue
// module id = 451
// module chunks = 1